import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-responsive';
import "../assets/css/datatables/datatables.min.css";
import {css} from '@emotion/core';
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import { CSVLink } from "react-csv";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class Consumable extends Component{
  constructor(props){
    super(props);
    this.state = {
      consumable_response: [],
      loading:true,
        ExcelHeaders : [
            { label: "S.No.", key: "SNo" },
            { label: "Consumable Id", key: "ConsumableId" },
            { label: "Available Quantity", key: "AvailableQuantity" }
        ],

       ExcelData : []
    }
  }

  componentDidMount() {
    this.refreshConsumables();
  }

  refreshConsumables(){
    const token = localStorage.usertoken;
    let warehouse_id = '';
    if(token != null) {
        const decoded = jwt_decode(token);
        warehouse_id = decoded.warehouse_id
    }
    if ($.fn.DataTable.isDataTable('#consumablesTable')) {
        $('#consumablesTable').DataTable().destroy();
    }
    axios.get(config.get('API_URL')+'/inventory/consumables?user_id='+warehouse_id,{
      headers: {
          Authorization: ` ${localStorage.usertoken}`,
          SalesforceToken: ` ${localStorage.salesforce_token}`
      }
    }).then(response => {
        var tempExlData=[];
        response.data.map((data, index)=>{
            var tempDate={
                SNo:index+1,
                ConsumableId:data.Name,
                AvailableQuantity:data.Available_Quantity__c
            }
            tempExlData.push(tempDate);
        })

      this.setState({
          consumable_response: response.data,
          ExcelData:tempExlData
      });
      $('#consumablesTable').DataTable({
          "oLanguage": {
              "sEmptyTable": "There are no consumables available"
          }
      });
      this.setState({
          loading: false
      })
    });
  }



  render(){

    let consumables_data = this.state.consumable_response.map((value, index) => {
      return (
          <tr key={index + 1}>
              <td>{index + 1}</td>
              <td>{value.Name}</td>
              <td>{value.SKU__r === undefined || value.SKU__r.Description__c=== undefined ? '': value.SKU__r.Description__c}</td>
              <td>{value.Available_Quantity__c}</td>
          </tr>
      )
    });
    return(
      <div className="content">
          <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12 pt-5">
                      <div>
                          <div className="col-mid-12 no-padd">
                            <div className="card title-card-bottom-space">
                              <div className="header">
                                  <h4 className="title">Consumables</h4>
                                  <p className="category"></p>
                              </div>
                            </div>
                          </div>
                          <div className="clearfix"></div>
                          <div className="content bgcolor">
                              <div className="row">
                                  <div className='sweet-loading'>
                                      <BeatLoader
                                          css={override}
                                          sizeUnit={"px"}
                                          size={20}
                                          color={'#123abc'}
                                          loading={this.state.loading}
                                      />
                                  </div>
                                  <div className="col-lg-12 ">

                                      <div className="p-5">
                                          <CSVLink data={this.state.ExcelData} headers={this.state.ExcelHeaders} >
                                             <span className="btn btn-primary pull-right "> Export To Excel</span>
                                          </CSVLink>
                                          <br />
                                      </div>

                                      <table className="table table-striped table-hover" id="consumablesTable">
                                          <thead>
                                          <tr>
                                              <th>S.No.</th>
                                              <th>SKU ID</th>
                                              <th>SKU Description</th>
                                              <th>Available Quantity</th>
                                          </tr>
                                          </thead>
                                          <tbody>
                                              {consumables_data}
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>

                          <div className="clearfix"></div>

                          <div className="footer">
                              <div className="stats"><i></i></div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    );
  }
}

export default Consumable;
